import { useMemo, useState } from 'react';
import { Box, Button, IconSort, Input, Wrapper } from '@screentone/core';
import debounce from 'lodash.debounce';

import styles from './LayoutSearchBar.module.scss';

export const DEBOUNCE_TIMEOUT = 500;

interface LayoutSearchBarProps {
  onSearchChange: (searchTerm: string) => void;
}

export const LayoutSearchBar = ({ onSearchChange }: LayoutSearchBarProps) => {
  const [searchInput, setSearchInput] = useState('');

  const handleSearchTextChange = useMemo(
    () => debounce((newSearchText: string) => onSearchChange(newSearchText), DEBOUNCE_TIMEOUT),
    [onSearchChange]
  );

  const handleSearchInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearchInput(e.target.value);
    handleSearchTextChange(e.target.value);
  };

  return (
    <Wrapper padding={{ top: 'sm', bottom: 'md' }}>
      <Box padding={{ all: 'sm' }} className={styles.layoutSearchBar}>
        <Input
          type="text"
          placeholder="Search by layout name or id"
          value={searchInput}
          onChange={handleSearchInputChange}
          margin={{ right: 'sm' }}
          data-testid="layouts-search-input"
        />
        <Button tertiary icon={IconSort} disabled data-testid="layouts-sort-filter">
          Sort: Create date
        </Button>
      </Box>
    </Wrapper>
  );
};
